import {
	createRouter,
	createWebHistory,
	type Router,
	type RouteRecordRaw,
} from "vue-router";

import { apiUrl } from "@/config";

/** Router Rules */
const routes: RouteRecordRaw[] = [
	{
		name: "default",
		path: "/",
		redirect: { name: "DashBoard" },
	},
	{
		component: async () => import("@/views/DashBoard.vue"),
		meta: {
			requireAuth: true,
		},
		name: "DashBoard",
		path: "/dashboard",
	},
	{
		component: async () => import("@/views/JobConfig.vue"),
		meta: {
			requireAuth: true,
		},
		name: "JobConfig",
		path: "/jobconfig",
	},
	{
		component: async () => import("@/views/PluginsOverview.vue"),
		meta: {
			requireAuth: true,
		},
		name: "Plugins",
		path: "/plugins",
	},
	{
		component: async () => import("@/views/JobOverview.vue"),
		meta: {
			requireAuth: true,
		},
		name: "JobOverview",
		path: "/joboverview",
	},
	{
		component: async () =>
			import("@/connect_plugins/UntisMdm/UntisMdmConfig.vue"),
		meta: {
			requireAuth: true,
		},
		name: "MdmUntis",
		path: "/plugins/untismdm/:id",
		props: true,
	},
	{
		component: async () =>
			import("@/connect_plugins/UntisMdm/UntisMdmTaskDetail.vue"),
		meta: {
			requireAuth: true,
		},
		name: "UntisMdmTaskDetail",
		path: "/tasks/untismdm/:taskid",
		props: true,
	},
	{
		component: async () =>
			import(
				"@/connect_plugins/UntisXschoolSchedule/UntisXschoolScheduleConfig.vue"
			),
		meta: {
			requireAuth: true,
		},
		name: "UntisXschoolSchedule",
		path: "/plugins/untis-xschool-schedule/:id",
		props: true,
	},
	{
		component: async () =>
			import(
				"@/connect_plugins/UntisXschoolSubstitution/UntisXschoolSubstitutionConfig.vue"
			),
		meta: {
			requireAuth: true,
		},
		name: "UntisXschoolSubstitution",
		path: "/plugins/untis-xschool-substitution/:id",
		props: true,
	},
	{
		component: async () =>
			import("@/connect_plugins/SchulConnex/SchulConnexConfig.vue"),
		meta: {
			requireAuth: true,
		},
		name: "SchulConnex",
		path: "/plugins/schulconnex/:id",
		props: true,
	},
	{
		component: async () =>
			import("@/connect_plugins/SchulConnex/SchulConnexTaskDetail.vue"),
		meta: {
			requireAuth: true,
		},
		name: "SchulConnexTaskDetail",
		path: "/tasks/schulconnex/:taskid",
		props: true,
	},
	{
		component: async () =>
			import("@/connect_plugins/ISTBackendUntis/ISTBackendUntisTaskDetail.vue"),
		meta: {
			requireAuth: true,
		},
		name: "ISTBackendUntisTaskDetail",
		path: "/tasks/istbackenduntis/:taskid",
		props: true,
	},
	{
		component: async () =>
			import("@/connect_plugins/UntisISTBackend/UntisISTBackendConfig.vue"),
		meta: {
			requireAuth: true,
		},
		name: "UntisISTBackend",
		path: "/plugins/untis-istbackend/:id",
		props: true,
	},
	{
		component: async () =>
			import("@/connect_plugins/ISTBackendUntis/ISTBackendUntisConfig.vue"),
		meta: {
			requireAuth: true,
		},
		name: "ISTBackendUntis",
		path: "/plugins/istbackend-untis-/:id",
		props: true,
	},
];
/** Vue Router */
const router: Router = createRouter({
	/**
	 * History Mode
	 *
	 * @see {@link https://router.vuejs.org/guide/essentials/history-mode.html}
	 */
	history: createWebHistory(apiUrl),
	routes,
});

export default router;
